import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, User } from 'lucide-react';
import { login } from '../../admin/api';
import BrandMark from '../../components/BrandMark';

export default function Login() {
  const [username, setUsername] = useState('admin');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr('');
    setLoading(true);
    try {
      await login(password, username);
      nav('/admin/courseware');
    } catch (e2) {
      setErr(e2.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4">
      <form onSubmit={submit} className="w-full max-w-sm rounded-2xl border border-gray-100 bg-white p-8 shadow-soft">
        <div className="mb-6 flex items-center gap-2.5">
          <BrandMark size="lg" />
          <div>
            <div className="text-lg font-extrabold tracking-tight text-slate-900">加太教育</div>
            <div className="text-xs text-gray-400">课件管理后台</div>
          </div>
        </div>

        <label htmlFor="user" className="mb-1.5 block text-sm font-medium text-slate-900">管理员账号</label>
        <div className="relative mb-4">
          <User className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
          <input id="user" value={username} onChange={(e) => setUsername(e.target.value)} className="form-input pl-9" autoFocus />
        </div>

        <label htmlFor="pw" className="mb-1.5 block text-sm font-medium text-slate-900">管理员密码</label>
        <div className="relative">
          <Lock className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
          <input id="pw" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="请输入密码" className="form-input pl-9" />
        </div>

        {err && <p className="mt-3 text-sm text-red-500">{err}</p>}

        <button type="submit" disabled={loading} className="btn btn-blue mt-5 w-full disabled:opacity-60">
          {loading ? '登录中' : '登录'}
        </button>

        <p className="mt-4 text-center text-xs text-gray-400">默认账号 admin，默认密码 touchcode123</p>
      </form>
    </div>
  );
}
